import React from 'react';
import ContactUs from '@/components/ContactUs';
import Section from '@/components/Section';
import { PageSectionsBySystemIdQuery, PageSectionFieldsFragment } from '../../@types/generated';
import { getOr } from '../utils/options';
import CardCollection from '@/components/CardCollection';
import Popup from 'components/src/popup';
import Banner from '@/components/Banner';

type Props = {
  sections: Array<PageSectionsBySystemIdQuery>;
  orderedIds: Array<string>;
};

function renderBanner(pageSectionFragment: PageSectionFieldsFragment) {
  if (pageSectionFragment.children?.__typename === 'Banner') {
    return (
      <Section
        childrenTypeName={pageSectionFragment.children?.__typename}
        sectionId={getOr(pageSectionFragment.id, '')}
        theme={getOr(pageSectionFragment.background, '')}
        marginTop={getOr(pageSectionFragment.marginTop, 32)}
        marginBottom={getOr(pageSectionFragment.marginBottom, 32)}
        gridType={getOr(pageSectionFragment.gridType as 'centered' | 'full', 'full')}
      >
        <Banner data={pageSectionFragment.children} />
      </Section>
    );
  }
  return null;
}

function renderCardCollection(pageSectionFragment: PageSectionFieldsFragment) {
  if (pageSectionFragment.children?.__typename === 'CardCollection') {
    return (
      <Section
        childrenTypeName={pageSectionFragment.children?.__typename}
        sectionId={getOr(pageSectionFragment.id, '')}
        theme={getOr(pageSectionFragment.background, '')}
        marginTop={getOr(pageSectionFragment.marginTop, 32)}
        marginBottom={getOr(pageSectionFragment.marginBottom, 32)}
        gridType={getOr(pageSectionFragment.gridType as 'centered' | 'full', 'full')}
      >
        <CardCollection
          cardCollectionId={pageSectionFragment.children.sys.id}
          headingSize="small"
          headingColor="text-black-100"
        />
      </Section>
    );
  }
  return null;
}

const HafaSambandPage = ({ sections, orderedIds }: Props) => {
  const [showThankYouModal, setShowThankYouModal] = React.useState<boolean>(false);
  const pageSections = sections.flatMap((x) => x.pageSectionCollection?.items as PageSectionFieldsFragment[]);
  pageSections.sort((a, b) => orderedIds.indexOf(a.sys.id) - orderedIds.indexOf(b.sys.id));

  const handleModalClose = () => {
    setShowThankYouModal(false);
  };

  return (
    <>
      {pageSections.map((x) => renderBanner(x))}
      <Section
        childrenTypeName={undefined}
        sectionId=""
        theme={'white-100'}
        marginTop={32}
        marginBottom={32}
        gridType={'full'}
      >
        <ContactUs showThankYouModal={setShowThankYouModal} />
      </Section>
      {pageSections.map((x) => renderCardCollection(x))}
      <Popup
        isOpen={showThankYouModal}
        title={'Takk fyrir'}
        text={'Skilaboð móttekin. Þjónustufulltrúar Sýnar verða í sambandi við þig.'}
        buttonText={'Loka glugga'}
        variant={'content'}
        onClose={handleModalClose}
        onClick={handleModalClose}
      />
    </>
  );
};

export default HafaSambandPage;
